/*
 * This is a reimplementation of what exists in our HTML template files
 * already. Once the React tree mounts, this is what gets rendered first, until
 * the app is ready to go.
 */

import {useEffect} from 'react'
import {View} from 'react-native'
import Svg, {Path, Polygon, Rect} from 'react-native-svg'

import {atoms as a} from '#/alf'

export function Splash({
  children,
  isReady,
}: React.PropsWithChildren<{isReady: boolean}>) {
  // hide the static one that's baked into the HTML - gets replaced by our React version below
  useEffect(() => {
    // double rAF ensures that the React version gets painted first
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const splash = document.getElementById('splash')
        if (splash) {
          splash.remove()
        }
      })
    })
  }, [])

  if (isReady) {
    return <>{children}</>
  }

  return (
    <View style={[a.fixed, a.inset_0, a.align_center, a.justify_center]}>
      <Svg width="73" height="73" viewBox="0 0 73 73">
        <Rect width="73" height="73" rx="15" ry="15" fill="#28004e" />

        <Polygon
          points="21.58 17.23 9.28 17.23 27.58 60.13 34.2 48.88 21.58 17.23"
          fill="#fff"
        />

        <Polygon
          points="36.76 37.88 46.47 36.99 54.01 11.55 66.73 11.55 46.47 60.25 36.76 37.88"
          fill="#61a38b"
        />

        <Path
          d="M39.12,37.67l6.19-.57c.7-.06,1.29-.55,1.49-1.22l7.35-24.27c.22-.73.88-1.23,1.64-1.23h8.87c1.22,0,2.05,1.24,1.58,2.37l-19.33,46.43c-.48,1.17-1.35,1.06-2.65,1.06l-6.56-20.19c-.47-1.07.25-2.28,1.42-2.39Z"
          fill="#61a38b"
        />

        <Path
          d="M30.58,28.15l3.78-5.98c1.46-2.31,4.96-1.85,5.77.77l4.14,13.49,5.58-19.2h11.88l-17.46,43.02-13.68-32.1Z"
          fill="#fff"
        />

        <Path
          d="M34.55,37.34l2.99-4.73c1.47-2.32,4.99-1.85,5.79.77l.93,3.04,7.54-26.05h12.72l-20.26,49.87-9.71-22.91Z"
          fill="#1df2ba"
        />
      </Svg>
    </View>
  )
}
